<template>
  <div class="range-slider d-flex">
    <div class="inputs">
      <label>
        Min
        <input
            type="number"
            :min="min"
            :max="high - step"
            :step="step"
            v-model.number="low"
            :disabled="disabled"
            @input="onLowInput"
            @change="onChange"
        />
      </label>
      <label>
        Max
        <input
            type="number"
            :min="low + step"
            :max="max"
            :step="step"
            v-model.number="high"
            :disabled="disabled"
            @input="onHighInput"
            @change="onChange"
        />
      </label>
    </div>

    <div class="slider">
      <div class="track"></div>
      <div
          class="range"
          :style="{ left: leftPct + '%', right: (100 - rightPct) + '%' }"
          aria-hidden="true"
      ></div>

      <input
          type="range"
          :min="min" :max="max" :step="step"
          :value="low"
          :disabled="disabled"
          @input="onLowInput"
          @change="onChange"
          aria-label="Minimum value"
      />
      <input
          type="range"
          :min="min" :max="max" :step="step"
          :value="high"
          :disabled="disabled"
          @input="onHighInput"
          @change="onChange"
          aria-label="Maximum value"
      />

      <div class="bubbles">
        <span :style="{ left: `calc(${leftPct}% )` }">{{ format(low) }}</span>
        <span :style="{ left: `calc(${rightPct}% )` }">{{ format(high) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RangeSlider",
  props: {
    // v-model:range — provide [minSelected, maxSelected]
    range: {
      type: Array,
      default: () => [0, 100],
    },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },
    format: { type: Function, default: (v) => v },
  },
  emits: ["update:range", "change"],
  data() {
    return {
      low: this.range[0],
      high: this.range[1],
    };
  },
  watch: {
    range: {
      immediate: true,
      handler([a, b]) {
        this.low = a;
        this.high = b;
      },
    },
  },
  computed: {
    leftPct() {
      return ((this.low - this.min) / (this.max - this.min)) * 100;
    },
    rightPct() {
      return ((this.high - this.min) / (this.max - this.min)) * 100;
    },
  },
  methods: {
    clampLow(v) {
      return Math.min(
          Math.max(v, this.min),
          Math.max(this.high - this.step, this.min)
      );
    },
    clampHigh(v) {
      return Math.max(
          Math.min(v, this.max),
          Math.min(this.low + this.step, this.max)
      );
    },
    onLowInput(e) {
      const v = Number(e.target.value);
      this.low = this.clampLow(v);
      this.$emit("update:range", [this.low, this.high]);
    },
    onHighInput(e) {
      const v = Number(e.target.value);
      this.high = this.clampHigh(v);
      this.$emit("update:range", [this.low, this.high]);
    },
    onChange() {
      this.$emit("change", [this.low, this.high]);
    },
  },
};
</script>

<style scoped>
.range-slider { width: 100%; max-width: 520px; display: grid; gap: .75rem; }
.inputs { display: flex; gap: .5rem; }
.inputs label { display: grid; gap: .25rem; font-size: .85rem; }
.inputs input[type="number"] { padding: .4rem .5rem; border: 1px solid #d0d7de; border-radius: 3px; width: 9ch; }

.slider { position: relative; height: 36px;flex: auto;margin-top:2em; margin-left:4em; }
.track {
  position: absolute; top: 50%; transform: translateY(-50%);
  height: 6px; width: 100%; background: #e5e7eb; border-radius: 999px;
}
.range {
  position: absolute; top: 50%; transform: translateY(-50%);
  height: 6px; background: #3b82f6; border-radius: 999px;
}
.slider input[type="range"] {
  -webkit-appearance: none; appearance: none;
  position: absolute; top: 0; left: 0; width: 100%; height: 36px;
  background: none; pointer-events: none;
}
.slider input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none; pointer-events: auto;
  height: 18px; width: 18px; border-radius: 999px;
  background: #fff; border: 2px solid #3b82f6; box-shadow: 0 1px 2px rgba(0,0,0,.15);
}
.slider input[type="range"]::-moz-range-thumb {
  pointer-events: auto; height: 18px; width: 18px; border-radius: 999px;
  background: #fff; border: 2px solid #3b82f6;
}
.slider input[type="range"]::-moz-range-track { background: transparent; }

.bubbles { position: absolute; top: -18px; left: 0; width: 100%; pointer-events: none; }
.bubbles span {
  position: absolute; transform: translateX(-50%); font-size: .75rem;
  background: #111827; color: white; padding: .15rem .4rem; border-radius: .35rem;
  white-space: nowrap;
}
</style>
